// External dependencies
import React, { Component, Fragment } from 'react';

// Internal dependencies
import FormField from './CustomBenchmarkFormField';
import { gradeFormValueTypes, customBenchmarkFormSettings } from '../../../../constants/adminConstants';

class GradeCutlinesFormBlock extends Component {
  render () {
    return (
      <Fragment>
        {customBenchmarkFormSettings.seasons.map((season, index) => { // for every season
          let firstDiv = (index == 0) ? <div className="formLabel gradeLabel"><span>{this.props.grade.label}</span></div> : <div></div>;
          return (
            <Fragment key={this.props.grade.value + "_" + season}>
              {firstDiv}
              <div className="formLabel"><span>{season}</span></div>
              {this.props.form.cutlines.map( cutline => { // for every cutline ids
                return (
                  <div key={this.props.grade.value + "_" + season + "_" + cutline.id}>
                    <FormField {...this.props}
                      isNumberForm={true}
                      id={{
                        cutline: cutline.id,
                        grade: this.props.grade.value,
                        season: index,
                        type: gradeFormValueTypes.cutlineValue,
                      }}
                      value= {this.props.form.cutlines[cutline.id].grades[this.props.grade.value].seasons[index].value}
                      placeholder="X"/>
                  </div>
                )
              })}
            </Fragment>
          )
        })}
      </Fragment>
    )
  }
}

export default GradeCutlinesFormBlock;